import { create } from "zustand";
import { persist } from "zustand/middleware";

// Zustand store for authentication (with persistence)
const useAuthStore = create(
  persist(
    (set) => ({
      user: null,
      token: null,
      roles: [],

      // Login action
      login: (user, token) => set({ user, token }),

      // Logout action
      logout: () => {
        set({ user: null, token: null, roles: [] });
        localStorage.removeItem("auth-storage");
        setTimeout(() => {
          window.location.href = process.env.REACT_APP_LOGOUT_URL;
        }, 100);
      },
      // Set user roles
      setRoles: (roles) => set({ roles }),

      // Set user information
      setUser: (user) => set({ user }),
    }),
    {
      name: "auth-storage", // Name of storage key in localStorage
      getStorage: () => localStorage, // Use localStorage to persist auth data
    }
  )
);

export default useAuthStore;
